import React, { useState, useEffect } from 'react';

// COMPONENTE DO RANKING REUTILIZÁVEL (BLOCO DO TOSHIBA COMPLETO)
const JanelaRankingLive = ({ aberto, aoFechar, aoClicar, emLive, dadosUtilizador, db, auth, idCanalLive }) => {
  const [listaRanking, setListaRanking] = useState([]);
  const [idLiveAnterior, setIdLiveAnterior] = useState(null);

  useEffect(() => {
    const canalId = idCanalLive || (emLive ? auth.currentUser?.uid : (dadosUtilizador?.id || dadosUtilizador?.uid));
    
    if (!aberto || canalId !== idLiveAnterior) {
      setListaRanking([]);
      if (canalId && aberto) setIdLiveAnterior(canalId);
      return;
    }

    if (!canalId) return;

    let unsubscribe;

    // Sequência de snapshots: durante gifting concorrente vários snapshots disparam
    // e o enriquecimento (getDoc) é assíncrono. Sem este contador, um snapshot mais
    // ANTIGO podia resolver depois e sobrescrever o score mais recente — fazendo o
    // TOP parecer "congelado". Só o snapshot mais recente escreve no estado.
    let sequenciaSnap = 0;

    const iniciarSensorRanking = async () => {
      const { collection, query, orderBy, onSnapshot, limit, doc, getDoc } = await import('firebase/firestore');
      // TOP 3 maiores presenteadores desta live
      const q = query(collection(db, "lives_activas", canalId, "ranking"), orderBy("totalGasto", "desc"), limit(3));

      unsubscribe = onSnapshot(q, async (snap) => {
        const meuSnap = ++sequenciaSnap;
        const base = snap.docs.map(d => ({ id: d.id, ...d.data() }));

        // Enriquece cada lugar com os dados REAIS do perfil (nomeCompleto + fotoUrl
        // da coleção "utilizadores"), em vez do que ficou guardado no ranking.
        const enriquecidos = await Promise.all(base.map(async (item) => {
          try {
            const perfilSnap = await getDoc(doc(db, "utilizadores", item.id));
            const perfil = perfilSnap.exists() ? perfilSnap.data() : {};
            return {
              ...item,
              nomeReal: perfil.nomeCompleto || item.nome || item.userName || "Craque",
              fotoReal: perfil.fotoUrl || perfil.fotoPerfil || perfil.photoURL || item.foto || item.fotoUrl || "/hero.png"
            };
          } catch (erroPerfil) {
            console.error("Erro ao carregar perfil do ranking:", erroPerfil);
            return {
              ...item,
              nomeReal: item.nome || item.userName || "Craque",
              fotoReal: item.foto || item.fotoUrl || "/hero.png"
            };
          }
        }));

        // Descarta resultados de snapshots já ultrapassados (evita score "preso").
        if (meuSnap === sequenciaSnap) {
          setListaRanking(enriquecidos);
        }
      });
    };

    iniciarSensorRanking();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [aberto, emLive, dadosUtilizador, db, auth, idCanalLive, idLiveAnterior]);

  if (!aberto) return null;

  return (
    <div style={{
      position: 'absolute', bottom: 0, left: 0, width: '100%', height: '50vh',
      background: '#050505', borderTop: '2px solid #39FF14',
      borderTopLeftRadius: '20px', borderTopRightRadius: '20px',
      zIndex: 1000020, padding: '20px', boxSizing: 'border-box',
      display: 'flex', flexDirection: 'column', color: 'white',
      boxShadow: '0 -5px 25px rgba(57, 255, 20, 0.2)'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <span style={{ fontSize: '16px', fontWeight: '900', color: '#39FF14', textTransform: 'uppercase' }}>
          🏆 TOP Presenteadores
        </span>
        <button 
          onClick={(e) => {
            e.stopPropagation();
            aoFechar();
          }} 
          style={{ background: 'none', border: 'none', color: '#666', fontSize: '24px', padding: '5px', cursor: 'pointer', pointerEvents: 'auto' }}
        >
          ✕
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '10px' }}>
        {listaRanking.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#555', fontSize: '14px', marginTop: '30px' }}>
            Nenhum presente enviado nesta Live ainda! ⚽
          </div>
        ) : (
          listaRanking.map((item, index) => {
            const ePrimeiroLugar = index === 0;
            return (
              <div 
                key={item.id} 
                onClick={(e) => {
                  e.stopPropagation();
                  aoFechar();
                  if (typeof aoClicar === 'function') {
                    aoClicar(item.userId || item.id);
                  }
                }}
                style={{
                  display: 'flex', alignItems: 'center', gap: '12px', padding: '12px',
                  borderRadius: '12px', marginBottom: '8px', boxSizing: 'border-box',
                  background: ePrimeiroLugar ? '#000000' : '#111111',
                  border: ePrimeiroLugar ? '1.5px solid #FFD700' : '1px solid #222',
                  boxShadow: ePrimeiroLugar ? '0 0 15px rgba(255, 215, 0, 0.4)' : 'none',
                  cursor: 'pointer',
                  pointerEvents: 'auto'
                }}
              >
                <div style={{ width: '24px', textAlign: 'center', fontWeight: '900', fontSize: '14px' }}>
                  {ePrimeiroLugar ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : `${index + 1}º`}
                </div>
                <img src={item.fotoReal || "/hero.png"} style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: ePrimeiroLugar ? '1.5px solid #FFD700' : '1px solid #444' }} alt="avatar" />

                <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: ePrimeiroLugar ? '#FFD700' : 'white', textShadow: ePrimeiroLugar ? '0 0 5px rgba(255, 215, 0, 0.5)' : 'none' }}>
                    {item.nomeReal}
                  </span>
                  {ePrimeiroLugar && (
                    <span style={{ fontSize: '9px', color: '#FFD700', marginTop: '2px', fontWeight: '500', opacity: 0.85 }}>
                      * Mantenha-se aqui e receba 5% do seu gasto de volta no fim da Live.
                    </span>
                  )}
                </div>
                
                <div style={{ fontSize: '13px', fontWeight: '900', color: '#39FF14' }}>{item.totalGasto || 0} ⚽</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default JanelaRankingLive;
